var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35395 21C10.0591 21.6224 10.9854 22 11.9998 22C13.0143 22 13.9405 21.6224 14.6456 21M17.9998 8C17.9998 6.4087 17.3677 4.88258 16.2425 3.75736C15.1172 2.63214 13.5911 2 11.9998 2C10.4085 2 8.88236 2.63214 7.75714 3.75736C6.63192 4.88258 5.99978 6.4087 5.99978 8C5.99978 11.0902 5.22025 13.206 4.34944 14.6054C3.61491 15.7859 3.24764 16.3761 3.2611 16.5408C3.27602 16.7231 3.31464 16.7926 3.46155 16.9016C3.59424 17 4.19237 17 5.38863 17H18.611C19.8072 17 20.4054 17 20.538 16.9016C20.685 16.7926 20.7236 16.7231 20.7385 16.5408C20.752 16.3761 20.3847 15.7859 19.6502 14.6054C18.7793 13.206 17.9998 11.0902 17.9998 8Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.6199542aee4b389b02a49d82665b6e09.svg";
export { ForwardRef as ReactComponent };